import { makeStyles, tokens } from "@fluentui/react-components";

export const useMetaDataSelectorStyles = makeStyles({
  container: {
    minWidth: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    rowGap: "5px",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: "5px",
  },

  selectorCombo: {
    border: 0,
    minWidth: "150px",
    width: "100%",
  },
  capitalCaseText: {
    textTransform: "capitalize",
  },
  option: {
    backgroundColor: "white",
    padding: "5px",
  },
  listbox: {
    maxHeight: "300px",
  },

  child: {
    height: "25px",
    lineHeight: "25px",
    width: "100%",
    minHeight: "25px",
  },
  textFallback: {
    marginBottom: "2px",
  },
});
